import { render } from "./studentsList.vue?vue&type=template&id=3dfefb10"
import script from "./studentsList.vue?vue&type=script&lang=js"
export * from "./studentsList.vue?vue&type=script&lang=js"

import "./studentsList.vue?vue&type=style&index=0&id=3dfefb10&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__